import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.reclamations;
export const reclamationsRoute = {
    path: rootPath,
    lazy: async () => {
        const { Reclamations } = await import('@/admin/modules/reclamations');
        return {
            element: (_jsx(ProtectedRoute, { claims: claimIds, children: _jsx(Reclamations, {}) })),
        };
    },
    handle: {
        crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
    },
};
